import actions from '@/store/modules/check-management/actions'
import mutations from '@/store/modules/check-management/mutations'
import state from '@/store/modules/check-management/state'

export default {
  actions,
  mutations,
  state
}
